export function isSuperAdmin(user) {
  return Boolean(user?.isSuperAdmin || user?.globalRole === "superadmin");
}

export function isStaff(user) {
  return Boolean(user?.globalRole === "staff");
}

export function canManageWebProfit(user) {
  return isSuperAdmin(user);
}
